import "../styles/css/bootstrap.min.css";
import Servicedata from "./Servicedata";
import { useContext, useEffect, useState } from "react";
import PaysContext from "../contexts/payscontext";
import AdminpaysContxt from "../contexts/adminpayscontext";
import axios from "axios";
import { Link } from "react-router-dom";
import PutformulaireRadio from   "./PutformulaireRadio"
import Toast from 'react-bootstrap/Toast'
import logo from '../assets/logo/logo.jpg'





export default function Adminradioform() {

  //Declaration de variables pour récupérer la liste des pays 
  // eagrimet.online
  //const urlgetpays = "http://localhost:8000/eagrimetApi/pays/";
  const urlgetpays = "https://eagrimet.online/eagrimetApi/pays/";
  const [lstPays, setLstPays] = useState([]);
  const [choixpays, SetChoixpays] = useState("");

  const v1context = useContext(PaysContext); // recupere le pays définit par défaut dans le fichier de context
  const v2context = useContext(AdminpaysContxt); // recupère le statut de l'administrateur par défaut à false

  // Declaration de variable useState pour modifier les 2 contextes
  const [payscon, SetPayscon] = useState(v1context);
  const[adminpayscon, SetAdminpayscon] = useState(v2context)

  


  // function qui permet d'actualiser le choix du pays effectué par l'Admin
  function handle(e) {
    SetChoixpays(e.target.value);
    
  }


  //UseEffet qui met à jour le UseState du contexte et du statut de l'Admin A chaque fois le pays change
  useEffect(() => {
    console.log("toto", choixpays);
    SetPayscon(choixpays);
    SetAdminpayscon(false)
  }, [choixpays]);


  // UseEffect qui permet de récupérer la liste des pays par l'API
  useEffect(() => {
    // Declaration de la fonction fetch de la liste des pays
    const fetchPays = async () => {
      try {
        const response = await fetch(urlgetpays, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
          },
        });
        if (!response.ok) {
          console.error("Error getting liste pays");
          return;
        }
        const result = await response.json();
        setLstPays(result);
      } catch {
        console.error("Error getting liste pays");
      }
    };
    // Trigger the fetch
    fetchPays();
  }, []);


  //const payscourant = PaysContext;
 // const adminpayscontext =  AdminpaysContxt
 const [btncreation, SetBtncreation] = useState(true)
 const [btnmodif, SetBtnmodif] = useState(true)

  const [adminregionradioExist, SetadminregionradioExist] = useState(false);
  const [showloginform , SetShowloginform] = useState(true)
  const [lstadminregionradio, setlstadminregionradio] = useState([]);
  const [page, setPage] = useState("")
  const [adminphone, setAdminphone] = useState("");
  const [adminpassword, setAdminpassword] = useState("");
  // const urlget = "http://localhost:8000/eagrimetApi/adminRadio/";
  const urlget = "https://eagrimet.online/eagrimetApi/adminRadio/";
  let axiosconfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
    },
  };
   
  const [showMsg, SetShowMsg] = useState(false);      
  const checkUserMessage ="Désolé, Utilisateur inexistant. Veuillez contacter l'Administrateur " 
  const toggleShowMsg = () => {SetShowMsg(false) } 
  const ouvreMsg = () => {SetShowMsg(true)}


  //fonction de gestion des boutons creation et modification
  function deconnecter(e){
    window.location.reload();
  }

  function handlecreation(e){
     SetBtncreation(true)
     SetBtnmodif(false)
     
  }

  function handlemodif(e){
    SetBtncreation(false)
    SetBtnmodif(true)
    
 }

  useEffect(() => {
    const fetchadminregionradio = async () => {
      await axios
        .get(urlget, axiosconfig)
        .then((resultat) => {
          setlstadminregionradio(resultat.data);
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchadminregionradio();
  }, []);

  // Verification si l'Admin pays existe
  function Checkadminregionradio() {
        console.log("liste admin pays ", lstadminregionradio);
        let resultat ={}
         resultat = lstadminregionradio.find(
         (adminp) =>
            adminp.numerotelephone === adminphone &&
            adminp.motdepasse === adminpassword &&
            adminp.pays === choixpays &&
            adminp.actif === true
        );
        if (resultat === undefined ){
            SetadminregionradioExist(false)
            SetShowloginform(true)
            console.log("vide", adminregionradioExist)
            // Utilisateur inexistant
            ouvreMsg();
            
        } 
        else{   
            SetShowloginform(false)         
            SetadminregionradioExist(true)
            console.log(typeof(resultat), adminregionradioExist)
            
        }        
        
    } // Fin fonction vérification existence Admin pays


  return (
    <div>
      {showloginform && (                

        <div className="row mx-auto p-2 col-md-6 ">
          <form id="form">
              <div className='d-flex flex-row-reverse'>                
                        {showMsg && 
                        <Toast show={showMsg} onClose={toggleShowMsg} >
                        <Toast.Header className='bg-success'>
                            <img src={logo} className='rounded-circle' height={30}  alt=""/>
                            <strong>&nbsp; eAgrimet</strong>
                        </Toast.Header>
                        <Toast.Body>{checkUserMessage} </Toast.Body>            
                    </Toast>
                    }                
                </div>





            <div className="border border-success">
              <h3>
                <i className="bi bi-mic-fill"></i>Radio{" "}                
              </h3>

              <div className="row justify-content-center ">
                <div className="col-6">
                  <i className="bi bi-telephone-fill"></i>
                  <input
                    id="Telephone"
                    type="text"
                    placeholder="Telephone"
                    className="form-control"
                    required
                    onChange={(e) => setAdminphone(e.target.value)}                 />
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="mb-4 col-6">
                  <i className="bi bi-key-fill"></i>
                  <input
                    id="motdepasse"
                    type="password"
                    placeholder="Mot de passe"
                    className="form-control"
                    required
                    onChange={(e) => setAdminpassword(e.target.value)}
                  />
                </div>

                <div className="row justify-content-center">
                  <div className="mb-4 col-6">
                    <label for="pays" className="form-label">
                      Pays
                    </label>
                    <select
                      id="pays"
                     onChange={(e) => handle(e)}
                      className="form-select form-control" >
                   
                      {lstPays.map((objpays) => {
                        return (
                          <option key={objpays.code} value={objpays.code}>
                            {objpays.pays}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

              </div>
              <div div className="row justify-content-end">
                <div className="mb-4 col-md-6">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={Checkadminregionradio}                    
                  >
                    Connecter
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
       {adminregionradioExist &&(<div className="row justify-content-start pt-3 ">
      <button className="btn  col-2 mx-3" onClick={(e)=> deconnecter(e)}><i className="bi bi-house"></i>  Logout</button>
       <button className="btn border-0  col-2 mx-3 d-none" onClick={(e)=> handlecreation(e)} disabled><i className="bi bi-database-add"></i> Creation</button>
       <button className="btn  col-2 "  onClick={(e)=> handlemodif(e)}><i className="bi bi-arrow-down-up"></i> Mise à jour</button>
       </div>)}
      <PaysContext.Provider value={payscon}>       
        <PutformulaireRadio adminExiste={adminregionradioExist} modemodif={btnmodif} numerotelephone={adminphone}/>      
      </PaysContext.Provider>
      
    </div>
  );
}
